module.exports = __webpack_public_path__ + "static/media/Headline.553b1376.png";